import { render, staticRenderFns } from "./PortalField.vue?vue&type=template&id=393b745a&scoped=true&"
import script from "./PortalField.vue?vue&type=script&lang=js&"
export * from "./PortalField.vue?vue&type=script&lang=js&"
import style0 from "./PortalField.vue?vue&type=style&index=0&id=393b745a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393b745a",
  null
  
)

export default component.exports